define.alias("ember-power-select/components/power-select-multiple", "settings/components/power-select-multiple");